    var swiper = new Swiper(".mySwiper", {
      navigation: {
        nextEl: ".swiper-button-next.review_next",
        prevEl: ".swiper-button-prev.review_prev",
      },
    });
  
 document.querySelectorAll('a[href^="#"]').forEach(link => {
  link.addEventListener("click", function (e) {
    e.preventDefault();

    const target = document.querySelector(this.getAttribute("href"));
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }

    // Close menu if header group has `menu-open`
    const headerGroup = document.querySelector('.shopify-section-group-header-group.menu-open');
    if (headerGroup) {
      const menuToggle = document.querySelector('[aria-controls="menu-drawer"]');
      if (menuToggle) {
        menuToggle.click();
      }
    }
  });
});